import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthPageShell } from '../components/auth/AuthPageShell';
import { REGISTER_CARD_CLASS } from './register/registerShared';

const ClaimAccountPage: React.FC = () => {
  const { t } = useTranslation('auth');
  const mainWebsiteUrl = process.env.REACT_APP_MAIN_WEBSITE_CALCULATOR_URL ?? '/';

  return (
    <AuthPageShell>
      <div className={REGISTER_CARD_CLASS}>
        <h1 className="text-center text-[22px] font-semibold leading-tight text-gray-900">
          {t('claim_account.title')}
        </h1>
        <p className="text-center text-sm text-gray-600">{t('claim_account.body')}</p>
        <div className="mx-auto flex w-full max-w-[400px] flex-col gap-4">
          <button
            type="button"
            onClick={() => window.location.replace(mainWebsiteUrl)}
            className="w-full rounded-md border border-[#6ECFCF] bg-[#6ECFCF] px-4 py-3 text-sm font-semibold text-gray-900 transition-colors hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-[#6ECFCF] focus:ring-offset-2"
          >
            {t('claim_account.go_to_website')}
          </button>
        </div>
      </div>
    </AuthPageShell>
  );
};

export default ClaimAccountPage;
